import { storageDateFormat } from '@/core';
import moment from 'moment';

export default function() {
	return {
		dateType: 'etd',
		date: {
			from: moment().subtract(7,'d').startOf('day')
				.format(storageDateFormat),
			to: ''
		},
		searchAreas: [],
		fromDespatchParty: [],
		toDeliveryParty: [],
		customer: [],
		goodsTypes: [],
		orderTypes: [],
		economicalStatus: [],
		orderStatus: [],
		references: [],
		referencesText: '',
		waybillNumber: []
	};
}
